import { FormValues } from "@src/components/Forms/Worlds/World";
import { World, WorldDTO } from "@src/types/global";
import { api } from "@src/utils/axios-instance";

export async function getWorld(id: string): Promise<World> {
    if (!id) throw new Error("No world ID given");
    const res = await api.get("/worlds/" + id);
    return res.data.data;
}

// Gets all the Worlds for the logged in user
export async function getAllWorlds(): Promise<{ worlds: World[] }> {
    const res = await api.get("/worlds?type=own");
    return res.data.data;
}

export async function getPublicWorlds(): Promise<{ worlds: World[] }> {
    const res = await api.get("/worlds?type=public");
    return res.data.data;
}

export async function createWorld(
    formData: FormValues,
): Promise<{ data: WorldDTO }> {
    const { cover_image: coverImage, ...world } = formData;
    try {
        const initialWorld = await api.post("/worlds", { world });
        const id = initialWorld.data.data.id;
        if (!coverImage || !Boolean(coverImage instanceof File))
            return initialWorld.data;
        const res = await uploadImage(id, coverImage);
        return res;
    } catch (e: any) {
        throw new Error(e);
    }
}

export async function uploadImage(
    id: string,
    image: File,
): Promise<{ data: WorldDTO }> {
    if (id == null || id == "") {
        throw Error("No ID given for update");
    }
    const formData = new FormData();
    formData.append("cover_image", image);
    const res = await api.put("/worlds/" + id, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return res.data;
}

export async function updateWorld({
    id,
    ...formData
}: FormValues): Promise<{ data: WorldDTO } | void> {
    if (id == null || id == "") {
        throw Error("No ID given for update");
    }

    const { cover_image: coverImage, ...world } = formData;
    try {
        const res = await api.put("/worlds/" + id, { world: world });
        if (!coverImage || !Boolean(coverImage instanceof File))
            return res.data;

        const imageRes = await uploadImage(id, coverImage);
        return imageRes;
    } catch (e: any) {
        throw new Error(e);
    }
}
export async function deleteWorld(id: string): Promise<void> {
    await api.delete("/worlds/" + id);
}
